import React from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';
import Modal from 'components/lib/Modal';

type Props = {
  open: boolean;
  description: string;
  isDeleting?: boolean;
  onCancel: () => void;
  onDelete: () => void | Promise<void>;
};

const StyledDeleteConfirmModal = styled(Modal)`
  &&& {
    .ant-modal-body {
      padding-bottom: 30px;
    }
  }
`;

const FooterRight = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

const FooterButton = styled(Button)`
  min-width: 120px;
`;

const DeleteBodyText = styled.div`
  font-size: 14px;
  color: var(--text-secondary);
`;

const ActionPlanEmailCampaignMessageDeleteConfirmModal = ({
  open,
  description,
  isDeleting = false,
  onCancel,
  onDelete,
}: Props) => (
  <StyledDeleteConfirmModal
    className="compact"
    open={open}
    centered
    onCancel={onCancel}
    destroyOnClose
    title="Delete Message?"
    width={540}
    footer={
      <FooterRight>
        <FooterButton type="primary" danger={false} loading={isDeleting} onClick={onDelete}>
          Delete
        </FooterButton>
        <FooterButton onClick={onCancel} disabled={isDeleting}>
          Cancel
        </FooterButton>
      </FooterRight>
    }
  >
    <DeleteBodyText>{description}</DeleteBodyText>
  </StyledDeleteConfirmModal>
);

export default ActionPlanEmailCampaignMessageDeleteConfirmModal;
